import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'

import {Grid, Typography, withStyles} from '@material-ui/core'
import Barcode from 'react-barcode'
import PmcPaymentMeans from '../PmcPaymentMeans'
import styles from './styles'

/**
 * This is the content of the Feedback sheet displayed when an Offline Payment successfully finishes.
 */
class OfflineFeedbackSheet extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            inShortVersion: false
        }
    }

    /**
     * Executed when the component was already mounted.
     */
    componentDidMount() {
        window.onresize = event => this.setState({...this.state, inShortVersion: event.target.innerWidth <= 611})
    }

    componentWillUnmount() {
        window.onresize = () => {
        }
    }

    /**
     * Renders the current component.
     *
     * @returns The JSX notation to build the UI of the component.
     */
    render() {
        const {
            classes, cardLogo, brandLogo, expirationDate, amount, operationNumber, barcode,
            title, paymentMeanName, secondExpirationDate, surcharge, isPmc
        } = this.props
        const {inShortVersion} = this.state
        return (
            <Grid container style={{position: 'relative'}}>
                <div className={classes.topDivider}/>

                <Grid container className={classes.top} justify={"space-between"} alignItems={"center"}>
                    <Grid item xs={12} sm>
                        <Grid container justify={"center"}>
                            <Grid item xs={"auto"} sm>
                                <img alt="" src={brandLogo} className={classes.brandLogo}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant="body1" color="inherit" className={classes.title}>
                                    {title ? title : ' '}
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="body1" color="inherit"
                                            className={classNames(classes.title, classes.voucherTitle)}>
                                    Comprobante de pago
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Grid container justify={"center"}>
                        <Grid item xs={"auto"}>
                            <img alt="" src={cardLogo} className={classes.cardLogo}/>
                        </Grid>
                    </Grid>
                </Grid>

                {createSubtitle(classes, paymentMeanName, isPmc)}

                <Grid item xs={12}>
                    <Grid container className={classes.expirationContainer}>
                        <Grid item xs={12} sm>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant={"subtitle1"}
                                                className={classes.expirationDate}
                                                align={"center"}>
                                        {!!secondExpirationDate ? `1° vencimiento ` : 'Vencimiento'}
                                        <span className={classes.expirationDateValue}> {expirationDate}</span>
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container alignItems={"center"} justify={"center"}>
                                        <Grid item xs={"auto"}>
                                            <Typography variant={"subtitle1"}
                                                        className={classes.toPayLine}
                                                        align={"center"}>
                                                A pagar
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={"auto"}>
                                            <Typography variant={"subtitle1"}
                                                        className={classes.toPay}>
                                                $ {amount}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        {!!secondExpirationDate && <Grid item xs>
                            {!inShortVersion && <div className={classes.expirationDivider}/>}

                            <Grid item xs={12} sm>
                                <Typography variant={"subtitle1"}
                                            className={classes.secondExpirationDate}
                                            align={"center"}>
                                    2° vencimiento
                                    <span className={classes.secondExpirationDateValue}> {secondExpirationDate}</span>
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container alignItems={"center"} justify={"center"}>
                                    <Grid item xs={"auto"}>
                                        <Typography variant={"subtitle1"}
                                                    className={classes.secondToPayLine}
                                                    align={"center"}>
                                            A pagar
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={"auto"}>
                                        <Typography variant={"subtitle1"}
                                                    className={classes.surcharge}
                                                    align={"center"}>
                                            $ {surcharge}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>}
                    </Grid>
                </Grid>

                {createBarCodeOrPmc(classes, barcode, inShortVersion, isPmc)}

                <Grid item xs={12}>
                    <Typography variant={"subtitle1"} className={classes.operationNumber}>
                        Número de operación: <span id="operationNumber">{operationNumber}</span>
                    </Typography>
                </Grid>
            </Grid>
        )
    }
}

function createBarCodeOrPmc(classes, barcode, inShortVersion, isPmc) {
    if (isPmc)
        return createPmcFeedback(classes);
    else
        return createBarCode(classes, barcode, inShortVersion);
}

function createPmcFeedback(classes) {
  const iconsUrl = `${window.env.ASSETS_URL}/images/icons`
  const pmcLogo = `${iconsUrl}/pagomiscuentas.svg`
  const homebankingLogo = `${iconsUrl}/homebanking.svg`
  return (
    <PmcPaymentMeans
      classes={classes}
      pmcLogo = {pmcLogo}
      homebankingLogo = {homebankingLogo}
    ></PmcPaymentMeans>
  )
}

function createBarCode(classes, barcode, inShortVersion) {
    return (
        <Grid id="barcode" item xs={12} className={classes.barCodeHolder}>
            <Barcode value={barcode}
                width={!inShortVersion ? 1.5 : 1.1}
                fontSize={14}
                height={70}
            />
        </Grid>
    )
}

function createSubtitle(classes, paymentMeanName, isPmc) {
    return (<Grid item xs={12}>
        <Typography variant={"subtitle1"}
                    className={classes.headline}
                    align={"center"}>
            {generateSubtitleText(paymentMeanName, isPmc)}
        </Typography>
    </Grid>)
}

function generateSubtitleText(paymentMeanName, isPmc) {
    if (isPmc)
        return <React.Fragment>La operación ha sido procesada satisfactoriamente.</React.Fragment>
    else
        return <React.Fragment>La operación ha sido procesada satisfactoriamente.<br/> Acércate a abonar en la sucursal
            de {paymentMeanName} más cercana.</React.Fragment>
}

OfflineFeedbackSheet.propTypes = {
    cardLogo: PropTypes.string.isRequired,
    amount: PropTypes.string.isRequired,
    expirationDate: PropTypes.string.isRequired,
    operationNumber: PropTypes.number.isRequired
}

const Styled = withStyles(styles)(OfflineFeedbackSheet)

export default Styled
